export const CHAT_EVENTS_OLD = {
  GLOBAL_HISTORY_CHAT_LOADED: 'GLOBAL_HISTORY_CHAT_LOADED',
  LOCAL_ROOM_CHAT_HITORY_LOADED_ERROR: 'LOCAL_ROOM_CHAT_HITORY_LOADED_ERROR',
  LOCAL_ROOM_CHAT_HITORY_LOADED: 'LOCAL_ROOM_CHAT_HITORY_LOADED',
}

export const CHAT_EVENTS = {
  OPEN: 3100,
  CLOSE: 3101,
  EXPAND: 3102,
  SHRINK: 3103,
  ON_OPEN_ROOM_CHAT: 3104,
  CHAT_SIDE_BAR_OPENED: 3005,
  CHAT_LIST_CLICKED: 3106,
  OPEN_SCENE_CHAT: 3107,
  OPEN_ONE_ON_ONE: 3108,
  PINN_CHAT: 3109,
  UNPINN_CHAT: 3110,
  OPEN_WORLD_CHAT: 3111,
  ON_OPEN_SCENE_CHAT: 3112,
  SINGLE_CHAT_ON_BACK_CLICKED: 3113,
  ON_OPEN_TOUR_CHAT: 3114,
  ON_CLOSE_TOUR_CHAT: 3115,
  OPEN_CHESS_CHAT: 3116,
  JUST_CLOSE_CHAT_UI: 3117,
  CLOSE_BUTTON_CLICKED_ON_SINGLE_CHAT: 3118,
}

